'use client';
import React from "react";
import { NewBackground } from "@workspace/ui/molecules/new-background";
import { Nav, NavMobile } from "@workspace/ui/molecules/nav";
import { maxWidthWrapperClassName } from "@workspace/utils";
import { FooterDetailed } from "@workspace/ui/molecules/footer-detailed";
import { NotFound } from "@/components/NotFound";

export default function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen flex-1 flex-col bg-background">
      {/* <NewBackground /> */}
      <NavMobile />
      <Nav
        maxWidthWrapperClassName={maxWidthWrapperClassName}
      />
      <NotFound />
      <NewBackground showAnimation />
      <FooterDetailed />
    </div>
  );
}
